import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TiptapCompactEditor from '../fields/rte/TiptapCompactEditor';
import TiptapStaticRenderer from '../fields/rte/TiptapStaticRenderer';

import ThemeContext from '../../../theme/ThemeContext';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;

const StyledCell = styled.div`
  box-sizing: border-box;
  max-width: 240px;
  min-width: 240px;
  padding: 4px;
  border-right: 1px solid ${(props) => props.theme.borderColor};
  border-bottom: 1px solid ${(props) => props.theme.borderColor};
`;

const StyledEditorWrapper = styled.div`
  min-height: 30px;

  .tiptap.ProseMirror {
    min-height: 24px;
    padding: 2px 4px;
    font-size: 12px;
  }
`;

class TableEditorRteValueCell extends Component {

  static contextType = ThemeContext

  static propTypes = {
    id: PropTypes.string,
    column: PropTypes.object,
    onBlur: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = { editing: false, localContent: props.column?.value || '' };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.editing !== this.state.editing) return true;
    if (nextState.localContent !== this.state.localContent) return true;
    return nextProps.column?._id !== this.props.column?._id;
  }

  componentDidUpdate(prevProps) {
    if (!this.state.editing && prevProps.column?._id !== this.props.column?._id) {
      this.setState({ localContent: this.props.column?.value || '' });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.blurTimer);
  }

  handleBlur = (json) => {
    this.latestJson = json;
    clearTimeout(this.blurTimer);
    this.blurTimer = setTimeout(() => {
      const { onBlur, column } = this.props;
      if (onBlur) onBlur(column._id, { value: this.latestJson });
      this.setState({ editing: false, localContent: this.latestJson });
    }, 150);
  }

  handleFocus = () => {
    clearTimeout(this.blurTimer);
  }

  handleStaticClick = () => {
    this.setState({ editing: true });
  }

  render() {
    const { id, column } = this.props;

    return (
      <StyledCell
        theme={this.context}
        data-testid={`${id}-${column._id}-rte-editor-cell`}
      >
        <StyledEditorWrapper>
          {this.state.editing ? (
            <TiptapCompactEditor
              autoFocus="end"
              content={this.state.localContent}
              disabled={false}
              onUpdate={() => {}}
              onBlur={this.handleBlur}
              onFocus={this.handleFocus}
              borderColor="transparent"
              borderRadius={4}
              borderWidth={1}
              padding={2}
              fontSize={12}
            />
          ) : (
            <TiptapStaticRenderer
              content={this.state.localContent}
              onClick={this.handleStaticClick}
            />
          )}
        </StyledEditorWrapper>
      </StyledCell>
    );
  }
}

class TableEditorRteRow extends Component {

  static contextType = ThemeContext

  static propTypes = {
    id: PropTypes.string,
    rteColumns: PropTypes.array,
    onBlur: PropTypes.func,
  }

  shouldComponentUpdate(nextProps) {
    const prev = this.props.rteColumns || [];
    const next = nextProps.rteColumns || [];
    if (prev.length !== next.length) return true;
    for (let i = 0; i < prev.length; i++) {
      if (prev[i]._id !== next[i]._id) return true;
    }
    return false;
  }

  render() {

    const { id, rteColumns, onBlur } = this.props;

    const cells = (rteColumns || []).map((column) => (
      <TableEditorRteValueCell
        key={column._id}
        id={id}
        column={column}
        onBlur={onBlur}
      />
    ));

    return (
      <StyledRow>
        {cells}
      </StyledRow>
    );

  }

}

export default TableEditorRteRow;
